"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { OutputPanel } from "#/features/output/ui/OutputPanel";
import { TreeViewPanel } from "#/features/treeViewer/ui/TreeViewPanel";
import { useI18nContext } from "#/shared/hooks";
import { CollapsiblePanel, CollapsiblePanelToggle } from "./CollapsiblePanel";
import { MOBILE_PHASE_NAV_HEIGHT } from "./MobilePhaseNavBar";
export const MobileResultsView: React.FC = () => {
  const $ = _c(29);
  const {
    LL
  } = useI18nContext();
  const [outputCollapsed, setOutputCollapsed] = useState(true);
  const [outputTab, setOutputTab] = useState("1");
  let t0;
  if ($[0] !== LL) {
    t0 = LL.OUTPUT();
    $[0] = LL;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Typography variant="caption" fontWeight={600}>{t0}</Typography>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const outputHeader = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOutputCollapsed(_temp);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleOutputToggle = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = newValue => {
      setOutputTab(newValue);
      setOutputCollapsed(false);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleOutputTabChange = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Box sx={{
      flex: 1,
      minHeight: 0,
      overflow: "hidden"
    }}><TreeViewPanel /></Box>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mt: 1,
      overflow: "hidden",
      flexShrink: 0
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "100%",
      minHeight: 52,
      paddingBottom: `calc(${MOBILE_PHASE_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      flex: 1,
      minWidth: 0
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOutputCollapsed(false);
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== outputTab) {
    t10 = <Box sx={t8}><OutputPanel headerOnly={true} value={outputTab} onTabChange={handleOutputTabChange} onTabBarClick={t9} /></Box>;
    $[12] = outputTab;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CollapsiblePanelToggle isCollapsed={true} onToggle={handleOutputToggle} aria-label="Expand output" />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10) {
    t12 = <Stack direction="row" alignItems="center" sx={t7}>{t10}{t11}</Stack>;
    $[15] = t10;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      height: "40vh",
      minHeight: 0,
      overflow: "hidden"
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = outputCollapsed ? "Expand output" : "Collapse output";
  let t15;
  if ($[18] !== outputCollapsed || $[19] !== t14) {
    t15 = <CollapsiblePanelToggle isCollapsed={outputCollapsed} onToggle={handleOutputToggle} aria-label={t14} />;
    $[18] = outputCollapsed;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== outputTab || $[22] !== t15) {
    t16 = <Box sx={t13}><OutputPanel value={outputTab} onTabChange={setOutputTab} trailingHeaderActions={t15} /></Box>;
    $[21] = outputTab;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== outputCollapsed || $[25] !== outputHeader || $[26] !== t12 || $[27] !== t16) {
    t17 = <Box sx={t4}>{t5}<Box sx={t6}><CollapsiblePanel header={outputHeader} collapsed={outputCollapsed} onToggle={setOutputCollapsed} hideHeaderRow={true} collapsedContent={t12}>{t16}</CollapsiblePanel></Box></Box>;
    $[24] = outputCollapsed;
    $[25] = outputHeader;
    $[26] = t12;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
};
function _temp(state) {
  return !state;
}